import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
// -------------------------------------------------------

class TaskBase extends React.Component {
  render() {
    let base = this.props.data;
    console.log(base);
    
    return (
      <div className="project-tasks">
        <Tasks base={base} />
      </div>
    );
  }
}
// -------------------------------------------------------

class Tasks extends React.Component {
  render() {
    let base = this.props.base;
    let workflow = base.workflow || {};
    let check_draft = base.check_draft || [];

    if( check_draft.length == 0 ){
      return (
        <div className="project-tasks">
          <div className="task-contents">
            <h2 className="none-draft">確認が必要な下書きがありません</h2>
          </div>
        </div>
      );
    }
    
    return (
      <div className="task-contents">
        
        <h1>下書き確認が必要なアカウントが<span>{check_draft.length}</span>件あります</h1>

        <div className="tasks-progress-action">
          <ul className="check-drafts">
            { check_draft.map((d, key) => {
              let influencer = (workflow.influencers || {})[d.insta_user_id];
              if( influencer == undefined ) return null;
              
              let img = '';
              try { img = d.media[0].media_url; } catch(e) {}
              
              return (
                <a key={key} href={'/draft/'+ d.unique_id} target="_blank">
                  <li>
                    <div className="img-thumbnail">
                      { (!Utils.isVideo(img))
                        ? <img src={img} onError={(e)=>{e.target.src=img}} />
                        : <video src={img} onError={(e)=>{e.target.src=img}} />
                      }
                    </div>
                    <div className="account-thumbnail">
                      { (influencer.thumbnail != null)
                        ? <img src={influencer.thumbnail} onError={(e)=>{e.target.src="/images/default.jpg"}} />
                        : <img src="/images/default.jpg" />
                      }
                    </div>
                    <div className="profile">
                      <p className="date">{Utils.setDate(d.create_date, 'YYYY/M/D')}</p>
                      <p className="insta_id">@{influencer.insta_id}</p>
                      <p className="version">Version.{d.version}</p>
                    </div>
                  </li>
                </a>
              );
            })}
          </ul>
        </div>
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default TaskBase;